module.exports = __webpack_public_path__ + "4d8739066c9f22a1e6ad3b24558bf6ff.jpg";